if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-drawer");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        // Validate recipient form fields if checkbox is checked
        const recipientForm = this.form.querySelector('recipient-form');
        if (recipientForm) {
          const checkbox = recipientForm.querySelector('[type="checkbox"]');
          if (checkbox && checkbox.checked) {
            const requiredFields = recipientForm.querySelectorAll('.recipient-fields input[required], .recipient-fields textarea[required], .recipient-fields select[required]');

            for (const field of requiredFields) {
              // Skip hidden fields (like the time field when not scheduled)
              if (field.offsetParent === null && field.type !== 'hidden') {
                continue;
              }
              // Check if field is empty or invalid (e.g., invalid email format)
              if (!field.value.trim() || !field.checkValidity()) {
                field.reportValidity();
                return;
              }
            }
          }
        }

        this.handleErrorMessage();

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        showCartGlobalLoader();

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cartNotification) {
          this.cartNotification.setActiveElement(document.activeElement);
          formData.append(
            "sections",
            this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id)
          );
        }
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        try {
          let response = await fetch(`${routes.cart_add_url}`, config).then(
            (res) => res.json()
          );

          $(document).trigger("product-form-responsed", [response]);
          document.dispatchEvent(new Event('product-form-responsed'));

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors: response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: formData.get("id"),
            });

          if (this.dataset.sendFreeGift === 'true' && this.dataset.freeGiftVariantId) {
            const giftRes = await fetch(routes.cart_add_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
              body: JSON.stringify({
                items: [{
                  id: Number(this.dataset.freeGiftVariantId),
                  quantity: 1,
                  properties: {
                    '_locked-quantity': 'true',
                    '_gift_for_kit': formData.get('id'),
                    '_womens-day-gift-set': 'true'
                  }
                }],
                sections: this.cartNotification?.getSectionsToRender()?.map(s => s.id) ?? [],
                sections_url: window.location.pathname
              })
            }).then(r => r.json());
            if (!giftRes.status) response = giftRes;
          }

          if (this.cartNotification?.renderContents) {
            this.cartNotification.renderContents(response);
          }
          animateCartDrawerProgressBar();

          const abGroup = localStorage.getItem('ab_test_group');
          if (abGroup && typeof setCartAttribute === 'function') {
            await setCartAttribute('ab_test_group', abGroup);
          }

        } catch (e) {
          console.error(e);
        } finally {
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("aria-disabled");
          hideCartGlobalLoader();
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

function calculateEffectiveProductCount() {
  const cartItems = document.querySelectorAll(".cart-item[data-product-count]");
  let totalEffectiveProducts = 0;

  cartItems.forEach((item) => {
    const productCount = parseInt(item.getAttribute("data-product-count")) || 1;
    const quantityAttr = item.getAttribute("data-quantity");
    const quantity = quantityAttr !== null ? parseInt(quantityAttr) : 1;
    // Skip items with quantity 0 (e.g., gift cards)
    if (quantity === 0) return;
    totalEffectiveProducts += productCount * quantity;
  });

  return totalEffectiveProducts;
}

function animateCartDrawerProgressBar() {
  const progressBar = document.querySelector(".cart-drawer-progress-bar-fill");
  const progressBarText = document.querySelector(
    ".cart-drawer-progress-bar-text"
  );
  const cartTruck = document.querySelector(
    ".cart-drawer-progress-bar-icon.cart-truck"
  );
  const cartGift = document.querySelector(
    ".cart-drawer-progress-bar-icon.cart-gift"
  );
  if (!progressBar) return;

  const effectiveProducts = calculateEffectiveProductCount();

  progressBar.setAttribute("data-effective-products", effectiveProducts);

  let newWidth = "0%";

  cartTruck?.classList.remove("active");
  cartGift?.classList.remove("active");

  if (effectiveProducts >= 2) {
    newWidth = "100%";
    cartTruck?.classList.add("active");
    cartGift?.classList.add("active");
  } else if (effectiveProducts === 1) {
    newWidth = "50%";
    cartTruck?.classList.add("active");
  } else {
    newWidth = "0%";
  }

  const prevWidth = window._cartProgressWidth || "0%";

  progressBar.style.transition = "none";
  progressBar.style.width = prevWidth;

  setTimeout(() => {
    progressBar.style.transition = "width 0.8s cubic-bezier(0.4, 0, 0.2, 1)";
    progressBar.style.width = newWidth;
    window._cartProgressWidth = newWidth;
  }, 300);

  // Always show the progress bar text
  progressBarText.classList.add("show");
}

document.addEventListener('DOMContentLoaded', animateCartDrawerProgressBar);

function showCartGlobalLoader() {
  const overlay = document.querySelector('.cart-global-loading-overlay');
  if (overlay) {
    overlay.classList.add('visible');
  }
}
function hideCartGlobalLoader() {
  const overlay = document.querySelector('.cart-global-loading-overlay');
  if (overlay) {
    overlay.classList.remove('visible');
  }
}

